import { getCookie, setCookie } from './cookies';

export default function getReferrer() {
    let documentReferrer = document.referrer ? new URL(document.referrer).hostname : '';
    let referrer = getCookie('referrer') || documentReferrer || 'direct';

    setCookie('referrer', referrer, 30);
    return referrer;
}